import { render, staticRenderFns } from "./SwNews.vue?vue&type=template&id=50d5e5fe&"
import script from "./SwNews.vue?vue&type=script&lang=js&"
export * from "./SwNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports